const linkNavi = document.querySelector('.link_navi');
const dropdownWrapper = document.querySelector('.navigationdropdown__wrapper.desktop_nav');
const dropdownInner = document.querySelector('.navigationdropdown__inner');
const dropdownContents = document.querySelector('.navigationdropdown__wrapper.desktop_nav .categorieslist__contents');
const dropdownOverlay = document.querySelector('.navigationdropdown__overlay');
const headerLinks = document.querySelectorAll('.header__nav-trigger');
const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
let headerHideTimeout;

const showDesktopDropdown = (hideSidebar) => {
  if (!dropdownWrapper || !isDesktop()) {
    return;
  }
  if (hideSidebar) {
    dropdownWrapper.classList.add('navigationdropdown__wrapper--no-sidebar');
  } else {
    dropdownWrapper.classList.remove('navigationdropdown__wrapper--no-sidebar');
  }
  dropdownWrapper.classList.remove('navigationdropdown__wrapper--hidden');
};

const setAllProductsState = (isAllProducts) => {
  if (!dropdownContents) {
    return;
  }
  dropdownContents.classList.toggle('all-products', Boolean(isAllProducts));
};

const hideDesktopDropdown = () => {
  if (!dropdownWrapper || !isDesktop()) {
    return;
  }
  dropdownWrapper.classList.add('navigationdropdown__wrapper--hidden');
  dropdownWrapper.classList.remove('navigationdropdown__wrapper--no-sidebar');
  setAllProductsState(false);
};

const activateContainerByCategory = (categoryValue) => {
  if (!dropdownWrapper || !categoryValue) {
    return;
  }
  const containers = dropdownWrapper.querySelectorAll('.collection-container');
  containers.forEach((container) => {
    container.classList.add('hidden-nav');
  });
  const correspondingContainer = dropdownWrapper.querySelector(
    `.collection-container[data-category="${categoryValue}"]`
  );
  if (correspondingContainer) {
    correspondingContainer.classList.remove('hidden-nav');
  }
};

const activateContainerByLink = (linkUrl) => {
  if (!dropdownWrapper || !linkUrl) {
    return;
  }
  const sidebarLink = dropdownWrapper.querySelector(`.categorieslist__sidebar.bottom a[data-link="${linkUrl}"]`);
  const containers = dropdownWrapper.querySelectorAll('.collection-container');
  const listItems = dropdownWrapper.querySelectorAll('.categorieslist__list-item');

  if (sidebarLink) {
    const categoryValue = sidebarLink.getAttribute('data-category');

    listItems.forEach((item) => {
      item.classList.remove('categorieslist__list-item--active');
    });

    const listItem = sidebarLink.closest('.categorieslist__list-item');
    if (listItem) {
      listItem.classList.add('categorieslist__list-item--active');
    }

    containers.forEach((container) => {
      container.classList.add('hidden-nav');
    });

    const correspondingContainer = dropdownWrapper.querySelector(
      `.collection-container[data-category="${categoryValue}"]`
    );
    if (correspondingContainer) {
      correspondingContainer.classList.remove('hidden-nav');
    }
    return;
  }

  containers.forEach((container) => {
    container.classList.add('hidden-nav');
  });

  const fallbackContainer = dropdownWrapper.querySelector(`.collection-container[collection_url="${linkUrl}"]`);
  if (fallbackContainer) {
    fallbackContainer.classList.remove('hidden-nav');
  }
};

linkNavi.addEventListener('mouseenter', function () {
  clearTimeout(headerHideTimeout);
  dataLayerPromise({
    event: 'navigation_interaction',
    section: 'top_bar',
    element: 'text_button',
    element_value: 'Produkty',
    interaction_type: 'hover',
  });
  showDesktopDropdown(false);
  setAllProductsState(true);
  const activeLink = dropdownWrapper.querySelector('.categorieslist__list-item--active [data-category]');
  const fallbackLink = dropdownWrapper.querySelector('.categorieslist__list-item [data-category]');
  const targetLink = activeLink || fallbackLink;
  if (targetLink) {
    activateContainerByCategory(targetLink.getAttribute('data-category'));
  }
});

linkNavi.addEventListener('mouseleave', function () {
  headerHideTimeout = setTimeout(() => {
    hideDesktopDropdown();
  }, 200);
});

dropdownOverlay.addEventListener('mouseenter', function () {
  hideDesktopDropdown();
});

dropdownInner.addEventListener('mouseenter', function () {
  clearTimeout(headerHideTimeout);
  const keepSidebarHidden = dropdownWrapper.classList.contains('navigationdropdown__wrapper--no-sidebar');
  showDesktopDropdown(keepSidebarHidden);
});

dropdownWrapper.addEventListener('mouseleave', function (event) {
  if (!dropdownWrapper.contains(event.relatedTarget)) {
    hideDesktopDropdown();
  }
});

headerLinks.forEach((link) => {
  link.addEventListener('mouseenter', () => {
    clearTimeout(headerHideTimeout);
    showDesktopDropdown(true);
    setAllProductsState(false);
    const linkUrl = link.getAttribute('data-link') || link.getAttribute('href');
    activateContainerByLink(linkUrl);
  });

  link.addEventListener('mouseleave', () => {
    headerHideTimeout = setTimeout(() => {
      hideDesktopDropdown();
    }, 200);
  });
});

const listItems = document.querySelectorAll('.navigationdropdown__wrapper.main_nav .categorieslist__list-item');
const containers = document.querySelectorAll('.navigationdropdown__wrapper.main_nav .collection-container');

listItems.forEach((item, index) => {
  item.addEventListener('mouseover', () => {
    const activeItem = document.querySelector('.categorieslist__list-item--active');
    if (activeItem) {
      activeItem.classList.remove('categorieslist__list-item--active');
    }

    item.classList.add('categorieslist__list-item--active');

    containers.forEach((container) => {
      container.classList.add('hidden-nav');
    });

    const activeCategory = item.querySelector('[data-category]');
    const categoryValue = activeCategory.getAttribute('data-category');

    const correspondingContainer = document.querySelector(
      `.navigationdropdown__wrapper.main_nav .collection-container[data-category="${categoryValue}"]`
    );

    if (correspondingContainer) {
      correspondingContainer.classList.remove('hidden-nav');
    }
  });
});

const navigationWrapper = document.querySelector('.navigationdropdown__wrapper.mobile_nav');
const iconLogo = document.querySelector('.icon-hamburger.open_navi');
const iconsCloseMobile = document.querySelectorAll('.icon-close_mobile');
const overlayMobile = document.querySelector('.navigation__mobile-modal__overlay');
const bodyElement = document.body;

iconLogo.addEventListener('click', function () {
  dataLayerPromise({
    event: 'navigation_interaction',
    section: 'top_bar',
    element: 'text_button',
    element_value: 'Produkty',
    interaction_type: 'click',
  });

  navigationWrapper.classList.add('opened');
  overlayMobile.classList.add('show');
  bodyElement.style.overflow = 'hidden';
});

iconsCloseMobile.forEach(function (iconCloseMobile) {
  iconCloseMobile.addEventListener('click', function () {
    navigationWrapper.classList.remove('opened');
    overlayMobile.classList.remove('show');
    bodyElement.style.overflow = 'auto';
    const containers = document.querySelectorAll('.mobile_products_container');
    containers.forEach(function (container) {
      container.classList.remove('opened');
    });
  });
});

const handleWindowResize = () => {
  if (window.innerWidth >= 1024) {
    navigationWrapper.classList.remove('opened');
    overlayMobile.classList.remove('show');
  }
};

window.addEventListener('resize', handleWindowResize);

handleWindowResize();

overlayMobile.addEventListener('click', function () {
  navigationWrapper.classList.remove('opened');
  overlayMobile.classList.remove('show');
  bodyElement.style.overflow = 'auto';
});

const categoryItemsMobile = document.querySelectorAll(
  '.navigationdropdown__wrapper.mobile_nav .categorieslist__list-item'
);

categoryItemsMobile.forEach(function (item) {
  item.addEventListener('click', function (event) {
    const hasHashLink = Array.from(item.querySelectorAll('a')).some((link) => link.getAttribute('href') === '#');

    if (hasHashLink) {
      const containers = document.querySelectorAll('.mobile_products_container');
      containers.forEach(function (container) {
        container.classList.remove('opened');
      });

      const nearestContainer = item.nextElementSibling;
      if (nearestContainer && nearestContainer.classList.contains('mobile_products_container')) {
        nearestContainer.scrollIntoView({ block: 'start' });
        nearestContainer.classList.add('opened');
      }

      event.preventDefault();
    }
  });
});

const backIcons = document.querySelectorAll('.mobile-modal__back-container');

backIcons.forEach(function (backIcon) {
  backIcon.addEventListener('click', function () {
    let containers = document.querySelectorAll('.mobile_products_container');
    containers.forEach(function (container) {
      container.classList.remove('opened');
    });
    const activeItems = document.querySelectorAll('.categorieslist__list-item.categorieslist__list-item--active');
    if (activeItems.length > 0) {
      activeItems.forEach(function (item) {
        item.classList.remove('categorieslist__list-item--active');
      });
    }
  });
});

const topbarDesktopLogo = document.querySelector('.header__logo.desktop-logo a');
const topbarMobileLogo = document.querySelector('.header__logo.mobile-logo a');

const logotypeEventData = {
  event: 'navigation_interaction',
  device_type: deviceType,
  user_id: window.customerData?.id ? window.customerData?.id : '',
  section: 'top_bar',
  element: 'logo_button',
  element_value: 'your_kaya',
  interaction_type: 'click',
};
if (topbarDesktopLogo) {
  topbarDesktopLogo.addEventListener('click', async (e) => {
    e.preventDefault();
    await dataLayerPromise(logotypeEventData);
    continueLinkClickEvent(e, topbarDesktopLogo.href);
  });
}
if (topbarMobileLogo) {
  topbarMobileLogo.addEventListener('click', async (e) => {
    e.preventDefault();
    await dataLayerPromise(logotypeEventData);
    continueLinkClickEvent(e, topbarMobileLogo.href);
  });
}
